angular
  .module('countriesApp')
  .service('CountryService', [
    '$q',
    'alertHandlingService',
    'CountryModel',
    'RequestService',
    'SlugAndIdService',
    function(
      $q,
      AlertHandling,
      CountryModel,
      Request,
      SlugAndId
    ) {
      let countries = null;
      let country = null;

      /**
       * Performs a request to the API to get the country information.
       * It stores the response data in this service, also handles if there is an error during the
       * request
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const request = id => Request.getCountry(id)
        .then(response => {
          country = new CountryModel(response.data);

          return country;
        })
        .catch(() => {
          AlertHandling.showGenericErrorMessage();

          return null;
        });

      /**
       * Performs a GET request to the API to get country information only if the promise is not
       * already running
       *
       * @param {string} slugAndId - Country slugAndId
       *
       * @returns {object} - Country promise object
       */
      const getBySlugAndId = function (slugAndId) {
        if (country && country.slugAndId === slugAndId) {
          return $q(resolve => resolve(country));
        }

        return request(SlugAndId.extractId(slugAndId));
      };

      /**
       * Performs a request to the API to get the whole list of countries
       *
       * @returns {object} - Request promise object
       */
      const getAll = () => {
        if(countries) {
          return $q(resolve => resolve(countries));
        }

        return Request.getCountries()
          .then(response => {
            countries = response.data;

            return countries;
          })
          .catch(() => {
            AlertHandling.showGenericErrorMessage();
          });
      };

      /**
       * Performs a request to the API to get the country search queries
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const getSearchQueries = id => Request.getSearchQueries(id)
        .then(response => response.data)
        .catch(() => {
          AlertHandling.showGenericErrorMessage();
        });

      return {
        getBySlugAndId,
        getAll,
        getSearchQueries
      };
    }
  ]);
